import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import { Stack } from '@mui/system';

import WaveUIAccordion from '@/shared/components/widgets/WaveUIAccordion';
import Payment from '@/shared/types/order/payment.type';

type GatewayDetailsPanelProps = {
  payment: Payment;
};

const GatewayDetailsPanel: FC<GatewayDetailsPanelProps> = ({ payment }) => {
  const { t } = useTranslation(['payments', 'common']);

  return (
    <WaveUIAccordion defaultExpanded title={t('payments:gatewayDetails')}>
      <Stack spacing={2}>
        <Stack spacing={1}>
          <Typography variant='body1'>{t('payments:processorId')}</Typography>
          <Typography
            variant='body2'
            color='text.secondary'
            textTransform='uppercase'
          >
            {payment.processor_id}
          </Typography>
        </Stack>

        <Stack spacing={1}>
          <Typography variant='body1'>
            {t('payments:externalTransactionId')}
          </Typography>
          <Typography
            variant='body2'
            color='text.secondary'
            textTransform='uppercase'
          >
            {payment.ext_transaction_id}
          </Typography>
        </Stack>
      </Stack>
    </WaveUIAccordion>
  );
};

export default GatewayDetailsPanel;
